import { Button, Divider, Drawer, Form, Select, Space, Typography } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";

const UpdateSubscription = ({ open, close, getMerchantList, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  var planExpiry = moment(selectedData.merchantinfosubscription.plan_started)
    .add(7, "d")
    .format("YYYY-MM-DD HH:mm:ss");

  const handleUpdateSubscription = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("merchant_id", selectedData.user_id);
    formdata.append(
      "old_plan",
      selectedData.merchantinfosubscription.current_plan
    );
    formdata.append(
      "description",
      `Updated subscription from ${selectedData.merchantinfosubscription.current_plan} to ${values.new_plan}.`
    );
    formdata.append(
      "sku_limit",
      // values.new_plan === "basic"
      //   ? 30
      //   :
      values.new_plan === "standard" ? 30 : 9999999999
    );
    formdata.append(
      "account_limit",
      // values.new_plan === "basic"
      //   ? 1
      //   :
      values.new_plan === "standard" ? 2 : 9999999999
    );
    formdata.append(
      "enable_sales_report",
      // values.new_plan === "basic" ? 0 :
      values.new_plan === "standard" ? 1 : 1
    );
    formdata.append(
      "enable_inventory_report",
      // values.new_plan === "basic" ? 0 :
      values.new_plan === "standard" ? 0 : 1
    );
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    axios
      .post("user/admin/merchant-subscription", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated subscription successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            getMerchantList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleUpdateDuration = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("merchant_id", selectedData.user_id);
    formdata.append(
      "new_plan_expiry",
      values.plan_duration === "12 months"
        ? moment(planExpiry).add(12, "M").format("YYYY-MM-DD HH:mm:ss")
        : moment(planExpiry).add(6, "M").format("YYYY-MM-DD HH:mm:ss")
    );
    formdata.append(
      "old_plan_expiry",
      selectedData.merchantinfosubscription.plan_expiry
    );
    formdata.append(
      "description",
      `Updated duration duration from ${
        selectedData.merchantinfosubscription.plan_expiry
      } to ${
        values.plan_duration === "12 months"
          ? moment(planExpiry).add(12, "M").format("YYYY-MM-DD HH:mm:ss")
          : moment(planExpiry).add(6, "M").format("YYYY-MM-DD HH:mm:ss")
      }.`
    );
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    axios
      .post("user/admin/merchant-duration", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated duration successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            getMerchantList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Update Subscription"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Typography
        style={{ fontWeight: "bold", fontSize: 16, marginBottom: 10 }}
      >
        Adjust Subscription Plan
      </Typography>
      <Form
        layout="vertical"
        name="update-subscription"
        initialValues={{ remember: true }}
        onFinish={handleUpdateSubscription}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="new_plan"
            label="Plan"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select size="large" showSearch>
              <Select.Option
                value="basic"
                disabled={
                  selectedData.merchantinfosubscription.current_plan === "basic"
                    ? true
                    : false
                }
              >
                Basic
              </Select.Option>
              <Select.Option
                value="standard"
                disabled={
                  selectedData.merchantinfosubscription.current_plan ===
                  "standard"
                    ? true
                    : false
                }
              >
                Standard
              </Select.Option>
              <Select.Option
                value="premium"
                disabled={
                  selectedData.merchantinfosubscription.current_plan ===
                  "premium"
                    ? true
                    : false
                }
              >
                Premium
              </Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="reason"
            label="Reason"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TextArea placeholder="Set reason" autoSize size="large" />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>

      <Divider style={{ border: "2px solid #000" }} />

      <Typography
        style={{
          fontWeight: "bold",
          fontSize: 16,
          marginBottom: 10,
          marginTop: 20,
        }}
      >
        Adjust Subscription Duration
      </Typography>
      <Form
        layout="vertical"
        name="update-duration"
        initialValues={{ remember: true }}
        onFinish={handleUpdateDuration}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="plan_duration"
            label="Plan Duration"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select size="large" showSearch>
              <Select.Option value="12 months">12 months</Select.Option>
              <Select.Option value="6 months">6 months</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="reason"
            label="Reason"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TextArea placeholder="Set reason" autoSize size="large" />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default UpdateSubscription;
